const trimTrailingSlash = (value?: string | null) =>
  (value || '').replace(/\/+$/, '');

const normalizeStoragePath = (value: string) =>
  value.replace(/^\/+/, '').replace(/^storage\/+/, '');

export const getApiBaseUrl = () => trimTrailingSlash(APP_API_BASE_URL);

export const getStorageBaseUrl = () => trimTrailingSlash(APP_STORAGE_BASE_URL);

export const joinStorageUrl = (
  baseUrl: string | undefined | null,
  value?: string | null,
) => {
  if (!value) {
    return '';
  }

  if (
    /^(https?:)?\/\//i.test(value) ||
    value.startsWith('data:') ||
    value.startsWith('blob:')
  ) {
    return value;
  }

  const normalizedPath = normalizeStoragePath(value);
  const normalizedBaseUrl = trimTrailingSlash(baseUrl);

  if (normalizedBaseUrl) {
    return `${normalizedBaseUrl}/${normalizedPath}`;
  }

  return `/storage/${normalizedPath}`;
};

export const resolveStorageUrl = (value?: string | null) =>
  joinStorageUrl(getStorageBaseUrl(), value);
